var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMailBlue = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12303_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 6.41659C2.75 5.93036 2.94315 5.46404 3.28697 5.12022C3.63079 4.77641 4.0971 4.58325 4.58333 4.58325H17.4167C17.9029 4.58325 18.3692 4.77641 18.713 5.12022C19.0568 5.46404 19.25 5.93036 19.25 6.41659V15.5833C19.25 16.0695 19.0568 16.5358 18.713 16.8796C18.3692 17.2234 17.9029 17.4166 17.4167 17.4166H4.58333C4.0971 17.4166 3.63079 17.2234 3.28697 16.8796C2.94315 16.5358 2.75 16.0695 2.75 15.5833V6.41659Z",
    stroke: "#1F5FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 6.41675L11 11.9167L19.25 6.41675",
    stroke: "#1F5FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12303_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMailBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mail-blue.4a9b2c0e395bd9d7b237b0581e6df9b4.svg";